var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoPlaylistIsLoaded)?_c('div',{ref:"wrapper"},[(_vm.videoPlaylistUrl)?_c('iframe',{staticClass:"rounded-lg",staticStyle:{"border":"none"},attrs:{"width":"100%","height":_vm.height,"src":_vm.videoPlaylistUrl,"allowfullscreen":""},on:{"load":_vm.loaded}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }